<template lang="tr">
  <div lang="tr" class="vertical-align-step-0 pb-4">

   
      <span class="product-header-field"> {{$t('En avantajlı şekilde 3’ü bir arada Kuruluş Paketi’ne sahip olmak ister misiniz')}}</span> 
    
      
      <div v-if="mainPackage && mainPackage.id">
        <div @click="changeMainPackage(mainPackage.code)" class="box-border2 selectable-field"
          v-bind:class="{ 'selected': isSelectedMainPackage }">
          <div class="box-content-field">
            <div>
              
              <div class="new-product-top-field">
                <div class="new-product-top-field-inside">
                  <div class="check-field" />
                
                  <span class="new-product-name">{{ getProductName(mainPackage)}}</span>
                </div>
                <div class="new-badge-field">{{ $t('Yeni Paket') }}</div> 

              </div>
           
            </div>
            <span class="new-product-description">{{ getProductDescription(mainPackage)}}</span>

            <div class="new-product-features">

             
              <div v-for="(feature,index) in packageFeatures">
                <div class="new-product-feature-item">{{feature.text}}</div>
              </div>
            </div>

            <hr />

            <div class="new-product-bottom-field">
              <div class="bottom-left-field">
                <div class="old-price-field overline"> 
                  <span class="old-price">{{formatPrice(138, '$')}} </span> 
                  <span class="fee-text"> {{
                    mainPackage.type === 'subscription' ? (mainPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                  }}{{'+'+$t('Eyalet Ücreti')}}</span>
                </div>
                <div class="new-price-field"> 
                  <span class="new-price">{{ formatPrice(mainPackage.net_price,mainPackage.currency)}} </span> 
                  <span class="fee-text">{{
                    mainPackage.type === 'subscription' ? (mainPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                  }} {{' + '+$t('Eyalet Ücreti')}}</span>
                </div>
              </div>

              <div class="bottom-right-field">
                <div class="price-badge-field">
                  <img src="/img/icons/lightning.svg" alt="price-badge" />
                  <span class="ml-1">{{$t('daha tasarruflu', {price: '%28'})}}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />
      <span class="product-header-field">{{$t('Almak istediğiniz hizmetleri seçin')}}</span>

      <div >
        <div  class="box-border2 selectable-field selected disabled">
          <div class="box-content-field">
            <div>
              
              <div  >
              
                <div class="d-flex justify-content-between">
                  <div class="new-product-top-field">
                    <div class="check-field disabled"  />
                
                    <span class="new-product-name">{{getProductName(formationPackage)}}</span>
                  </div>
                  <div class="old-price-field" :class="{'overline': isSelectedMainPackage}">
                  <span class="secondary-price-field" >{{formatPrice(formationPackage.net_price,formationPackage.currency)}}</span><span>{{'+'+$t('Eyalet Ücreti')}}</span>
                </div>
                </div>

              </div>
           
            </div>
            <span class="new-product-description">{{getProductDescription(formationPackage)}}</span>

            <div >
              <div class="alert-mukellef-warning mt-3 mb-0">
                <div class="d-flex">
                  <i class="fa fa-info-circle mr-2 alert-icon-size alert-icon-spacing"></i>
                  <div v-tippy="{content: $t('Eyalet ücreti eklenecektir Tooltip')}">
                    <span class="alert-text-new">{{$t('Eyalet ücreti eklenecektir')}}</span> 
                  </div>
                </div>
              </div>
            </div>
            
            
          
          </div>
        </div>
      </div>
  
      <div v-for="(product,index) in products" :key="product.id">
        <div @click="changeSecondaryProducts(product.code)" class="box-border2 selectable-field"
          v-bind:class="[{ 'selected': secondaryProducts.includes(product.code) }]" >
          <div class="box-content-field">
            <div>
              
              <div  >
              
                <div class="d-flex justify-content-between">
                  <div class="new-product-top-field">
                    <div class="check-field"   />
                
                    <span class="new-product-name">{{getProductName(product)}}</span>
                  </div>
                  <div class="old-price-field" :class="{'overline': isSelectedMainPackage}">
                  <span class="secondary-price-field" >{{formatPrice(product.net_price,product.currency)}}</span>
                </div>
                </div>

              </div>
           
            </div>
            <span class="new-product-description">{{getProductDescription(product)}}</span>

           
            <div v-if="product.code === 'USEIN'">
              <div class="alert-mukellef-warning mt-3 mb-0" @click.stop.prevent="openModal('whatIsEinModal')">
                <div class="d-flex">
                  <i class="fa fa-info-circle mr-2 alert-icon-size alert-icon-spacing"></i>
                  <div class="alert-inner-field">
                    <span class="alert-text-new">{{$t('EIN Nedir? Neden Başvurmalıyım?')}}</span> 
                    <i class="fa fa-chevron-right chevron-item" aria-hidden="true"></i>

                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="product.code === 'US_BOI'" >
              <div class="alert-mukellef-warning mt-3 mb-0" @click.stop.prevent="openModal('whatIsBoiModal')">
                <div class="d-flex">
                  <i class="fa fa-info-circle mr-2 alert-icon-size alert-icon-spacing"></i>
                  <div class="alert-inner-field">
                    <span class="alert-text-new">{{$t('BOI Form Nedir? Neden Başvurmalıyım?')}}</span> 
                    <i class="fa fa-chevron-right chevron-item" aria-hidden="true"></i>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
     
   

 

  <usSetupConfirmationModal :main-package="mainPackage"  :package-features="packageFeatures" ref="usSetupConfirmationModal" @confirm-setup-package="confirmSetupPackage" @cancel="cancelSetupPackage"  />
  <usAddressConfirmationModal  :address-package="addressPackage"ref="usAddressConfirmationModal" @confirm-address-package="sendForm" />
  <whatIsEinModal ref="whatIsEinModal"  />
  <whatIsBoiModal ref="whatIsBoiModal"  />
  </div>
</template>

<script>
import RegisterStore from '../../../stores/register';
import CompanyStore from '../../../stores/company';

import usSetupConfirmationModal from '../../modals/usSetupConfirmation.vue';
import usAddressConfirmationModal from '../../modals/usAddressConfirmation.vue';
import whatIsEinModal from '../../modals/whatIsEin.vue';
import whatIsBoiModal from '../../modals/whatIsBoi.vue';

export default {
  components: {
    usSetupConfirmationModal,
    usAddressConfirmationModal,
    whatIsEinModal,
    whatIsBoiModal,
  },
  computed: {
    isSelectedMainPackage() {
      return this.setupPackageCodes.every((element) => this.secondaryProducts.includes(element));
    },
  },
  props: {
    states: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isTransfer: {
      type: Boolean,
      default: false,
    },
    usProducts: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      setupPackageCodes: ['USEIN', 'US_BOI'],
      products: [],
      secondaryProducts: [],
      company: {
        global_activity_area: null,
      },
      commissionProduct: 'USSTATEFEE_PAYMENT_COMMISSION',
      stateFeeProduct: {},
      expressFormationProduct: {},
      otherStateAdditionalFeeProduct: 'OTHERSTATEADDITIONALSETUPFEE',
      mainPackage: {},
      addressPackage: {},
      formationPackage: {},
      packageFeatures: this.$t('Us Formation Maddeleri'),
      callback: null,
    };
  },
  created() {
    CompanyStore.dispatch('getCompany').then((s) => {
      this.endWaiting();
      if (s.data.data.length) {
        this.company = s.data.data[0];

        if (this.$store.state.removePackageData) {
          this.company.package = [];
        }

        const mainPackage = this.usProducts.find((element) => element.code === 'US_FORMATION_PACKAGE');

        if (mainPackage) {
          mainPackage.net_price = this.getPrice(mainPackage.prices.data);
          this.mainPackage = mainPackage;
        }

        const addressPackage = this.usProducts.find((element) => element.code === 'US_ADDRESS_PACKAGE_PRODUCT');

        if (addressPackage) {
          addressPackage.net_price = this.getPrice(addressPackage.prices.data);
          this.addressPackage = addressPackage;
        }

        const formationPackage = this.usProducts.find((element) => element.code === 'US_FORMATION');

        if (formationPackage) {
          formationPackage.net_price = this.getPrice(formationPackage.prices.data);
          this.formationPackage = formationPackage;
        }

        this.products = this.setupPackageCodes
          .map((code) => this.usProducts.find((item) => item.code === code))
          .filter((item) => item);

        this.products = this.products.map((item) => ({
          ...item,
          net_price: this.getPrice(item.prices.data),
        }));

        if (this.company.package) {
          const setupPackageCodes = [...this.setupPackageCodes];

          const secondaryProducts = this.company.package
            .filter((code) => setupPackageCodes.includes(code))
            .reduce((unique, item) => {
              if (!unique.includes(item)) {
                unique.push(item);
              }
              return unique;
            }, []);

          if (secondaryProducts.length) {
            this.secondaryProducts = secondaryProducts;
          } else {
            if (!this.company.package.includes('US_FORMATION')) {
              this.secondaryProducts = ['USEIN', 'US_BOI'];
            }
          }
        } else {
          this.secondaryProducts = ['USEIN', 'US_BOI'];
        }

        const uppercaseState = this.company.state.toUpperCase();
        const selectedStateProducts = this.usProducts.filter(function (item) {
          if (item.code.includes(uppercaseState)) {
            return true;
          }
          return false;
        });
        if (selectedStateProducts.length) {
          const expressFormationProduct = selectedStateProducts.find((x) => x.code.includes('USEXPRESSFORMATION'));
          if (expressFormationProduct) {
            expressFormationProduct.final_price = this.getPrice(expressFormationProduct.prices.data);
            this.expressFormationProduct = expressFormationProduct;
          }
          this.stateFeeProduct = selectedStateProducts.find((x) => x.code.includes('USSTATEFEE'));
        }
      }
    });
  },

  methods: {
    openModal(data) {
      const element = this.$refs[data].$el;
      $(element).modal('show');
    },
    cancelSetupPackage() {
      const element = this.$refs.usAddressConfirmationModal.$el;
      $(element).modal('show');
    },
    confirmSetupPackage() {
      this.secondaryProducts = ['USEIN', 'US_BOI'];
      const element = this.$refs.usAddressConfirmationModal.$el;
      $(element).modal('show');
    },
    changeMainPackage(data) {
      this.secondaryProducts = [...this.setupPackageCodes];
    },

    getPrice(prices) {
      const price = prices.find((x) => x.company_type_id === this.company.company_type_id).price;
      return price;
    },
    changeSecondaryProducts(code) {
      if (this.secondaryProducts.includes(code)) {
        const index = this.secondaryProducts.findIndex((item) => item === code);
        this.secondaryProducts.splice(index, 1);
      } else {
        this.secondaryProducts.push(code);
      }
    },
    openSummaryModal(callback) {
      this.callback = callback;

      if (!this.secondaryProducts) {
        this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
        return;
      }

      if (!this.isSelectedMainPackage) {
        const element = this.$refs.usSetupConfirmationModal.$el;
        $(element).modal('show');
      } else {
        const element = this.$refs.usAddressConfirmationModal.$el;
        $(element).modal('show');
      }
    },
    sendForm() {
      this.startWaiting();
      let packageData = [];

      packageData = [...this.secondaryProducts];
      packageData.push('US_FORMATION');
      packageData.push('US_ADDRESS_PACKAGE_PRODUCT');

      if (this.stateFeeProduct.code) {
        packageData.push(this.stateFeeProduct.code);
        packageData.push(this.commissionProduct);
      }

      if (
        this.company.state.toUpperCase() === 'DELAWARE' &&
        this.expressFormationProduct &&
        this.expressFormationProduct.code
      ) {
        packageData.push(this.expressFormationProduct.code);
      }

      if (!this.states.some((state) => state.key === this.company.state)) {
        packageData.push(this.otherStateAdditionalFeeProduct);
      }

      RegisterStore.dispatch('package', {
        packages: packageData,
      }).then((s) => {
        if (s.data.success === false) {
          this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
          this.endWaiting();
          return;
        }
        this.$store.commit('setremovePackageData', false);
        this.$store.commit('setCompanyId', s.data.data.id);
        this.callback(true);
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
